import { get } from 'lodash'

export const getCurrentRegistration = state => {
  const currentReg = getCurrentRegistrationId(state)

  return !currentReg ? {} : get(state, `formData.registrations.${currentReg}`)
}

export const getCurrentRegistrationId = state => get(state, 'formData.currentRegistration')

export const getOrderId = state => get(state, 'formData.orderId')

export const getRegistrationData = state => get(state, 'formData.registrationData')

export const getSessions = state => get(state, 'formData.sessions')

export const getPaymentData = state => get(state, 'payment.paymentData')

export const getPaymentType = state => get(state, 'payment.paymentType')

export const getSessionId = state => get(state, 'formData.sessionId')

export const getSelectedPaymentGateway = state => get(state, 'payment.paymentMethod')

export const getInitialPaymentGateway = state => get(state, 'formData.initialPaymentGateway')

export const getRegistrationProducts = state => {
  const registrations = get(state, 'formData.registrations')
  const teamRegistration = get(state, 'formData.team')

  const mergedRegistrations = {
    ...registrations,
    teamRegistration,
  }

  const registrationProducts = Object.values(mergedRegistrations).reduce((acc, registration) => {
    const {
      newProducts = {},
      newSubEventProducts = {},
      newAddOnProducts = {},
      teamProducts = {},
      teamSubEventProducts = {},
      teamAddOns = {},
    } = registration

    const allProducts = {
      ...newProducts,
      ...newSubEventProducts,
      ...newAddOnProducts,
      ...teamProducts,
      ...teamSubEventProducts,
      ...teamAddOns,
    }

    Object.keys(allProducts).forEach(sfid => {
      const product = allProducts[sfid]
      const { checked, quantity = 0 } = product || {}

      if (!product || !checked) {
        return
      }

      if (!acc[sfid]) {
        acc[sfid] = {
          sfid,
          quantity: Number(quantity),
        }

        return
      }

      acc[sfid].quantity += Number(quantity)
    })

    return acc
  }, {})

  return registrationProducts
}

export const getTeamCode = state => get(state, 'formData.team.teamCode')
